import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../services/api';

const SamlCallback = ({ onLogin }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    const plan = searchParams.get('plan') || 'free_trial';

    if (!token) {
      toast.error('No token received from SSO');
      navigate('/login');
      return;
    }

    const finish = (userData) => {
      if (window.opener) {
        try {
          localStorage.setItem('token', token);
          localStorage.setItem('tok', token);
          localStorage.setItem('user', JSON.stringify(userData));
          window.opener.postMessage({ type: 'saml-login', token, user: userData }, window.location.origin);
        } catch (e) {
          console.error('[SamlCallback] postMessage failed', e);
          onLogin?.(token, userData);
          navigate('/dashboard');
        }
        window.close();
      } else {
        onLogin?.(token, userData);
        toast.success('Signed in with Company SSO');
        navigate('/dashboard');
      }
    };

    const userData = { email: email || '', plan, id: '' };
    localStorage.setItem('token', token);
    localStorage.setItem('tok', token);
    api.get('/me')
      .then((res) => {
        if (res.data) {
          finish({ email: res.data.email || email, plan: res.data.plan || plan, id: res.data.id || '' });
        } else {
          finish(userData);
        }
      })
      .catch(() => finish(userData));
  }, [searchParams, navigate, onLogin]);

  return (
    <div className="loading-screen">
      <div className="loader"></div>
      <p style={{ marginTop: '1rem', color: 'var(--color-muted)' }}>Completing sign-in...</p>
    </div>
  );
};

export default SamlCallback;
